
import ImageLoader from "@/assets/scripts/ImageLoader";
import HeaderLayout from "@/components/layouts/Header.vue";
import FooterLayout from "@/components/layouts/Footer.vue";
import DoubleBlock from "@/components/blocks/Double.vue";

export default {
  name: "PortfolioView",
  components: {
    HeaderLayout,
    FooterLayout,
    DoubleBlock,
  },
  data() {
    return {
      founderImage: ImageLoader.loadImageSrc("assets/images/decorators/founder.jpg"),
    }
  },
};
